import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ViewRouterSwitch extends Vue {
	@Prop() public isVisible!: boolean;
	@Prop() public isOn!: boolean;
	@Prop() public titleOn!: string;
	@Prop() public titleOff!: string;
	@Prop() public pathOn!: string;
	@Prop() public pathOff!: string;
	private selected: boolean = false;

	public created(): void {
	}

	@Watch('isVisible')
	private onIsVisibleChange(newIsVisible: boolean, oldIsVisible: boolean): void {
		// visibleがfalseになったら選択状態をデフォルトに戻す
		this.selected = newIsVisible ? this.selected : false;
	}

	@Watch('isOn')
	private onIsOnChange(newIsOn: boolean, oldIsOn: boolean): void {
		this.selected = newIsOn;
	}

	private onClick(path: string, event: Event): void {
		if (path === '') {
			return;
		}
		const element: HTMLElement = event.currentTarget as HTMLElement;
		if (element.classList.contains('selected')) {
			return;
		}
		this.selected = !this.selected;
		this.$router.push(path);
	}
}
